module.exports = __webpack_public_path__ + "static/media/Brios-Frutal-Descripcion-Desktop.9891ed93.webp";